// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n:scope .el-autocomplete[data-v-4d50badd]{\n  width: 100%;\n}\n.el-form--label-top .el-form-item__label[data-v-4d50badd] {\n  padding-bottom: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
